<div class="toggle-wrapper">
  <p-inputSwitch
    [disabled]="disabled"
    [(ngModel)]="isChecked"
    (onChange)="onToggleChange($event)">
  </p-inputSwitch>
</div>
